import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Button,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changeEventType, togglePointwiseShow, toggleVisibility, changeEventStarTypes } from "Redux/eventSlice";
import {
  changeHeatMap2Mode,
  SelectingType,
  ColorStepType,
  toggleVisibility as toggleZones,
  changeHeatMap2ColorStep,
  toggleShowHeatMap2Numbers,
  changeApplySelected,
} from "Redux/zonesSlice";
import { useState } from "react";
import { EVENTS_TYPES } from "Constants/traffic";
import { changeDataForPost, createTrafficAnalysisStarUrl } from "Redux/starSlice";
import MenuButton from "./Button";

const INPUTS_WIDTH = "250px";

export default function Events() {
  const dispatch = useAppDispatch();

  const { eventTypes, visible, pointwiseShow, eventStarTypes } = useAppSelector((state) => state.event);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleSwitch = () => {
    dispatch(toggleVisibility());

    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=da4e3cf5-9b83-4ac2-b363-3e940ceea0bc&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=6f832c94-d666-4cc2-84b3-c0cf8c4d0da8&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };

  const handleClick = (type: string, starType: string) => {
    if (eventTypes.includes(starType)) {
      const newEventStarTypes = eventStarTypes.filter((c) => c !== starType);
      const urlValue = newEventStarTypes.map((t) => `{"$type":"WebParameterValue","Id":"${t}","Value":"${t}"}`);
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=da4e3cf5-9b83-4ac2-b363-3e940ceea0bc&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=6f832c94-d666-4cc2-84b3-c0cf8c4d0da8&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(changeEventStarTypes(newEventStarTypes));
    } else {
      const urlValue = [...eventStarTypes, starType].map((t) => `{"$type":"WebParameterValue","Id":"${t}","Value":"${t}"}`);
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=da4e3cf5-9b83-4ac2-b363-3e940ceea0bc&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=6f832c94-d666-4cc2-84b3-c0cf8c4d0da8&paramvalues={"827786fd-9b7f-70f3-2429-e24fe88d3f88":[{"Value":{"Id":null,"Value":"2024-06-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"42e49912-984e-04a2-b9e4-29489e7ba907":[{"Value":{"Id":null,"Value":"2024-06-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"94cee3c1-016f-c7e4-2032-b6129dfb2ece":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(changeEventStarTypes([...eventStarTypes, starType]));
    }
    dispatch(changeEventType(type));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row">
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Button onClick={handleMarkerPointWise} variant={pointwiseShow ? "contained" : "light"} style={{ marginRight: "10px" }}>
            نمایش نقطه ای
          </Button>
        </Stack>
        {EVENTS_TYPES.map((events) => (
          <MenuButton
            isActive={eventTypes.includes(events.type)}
            onClick={() => handleClick(events.type, events.text)}
            title={events.text}
          >
            {!eventTypes.includes(events.type) ? (
              <img src={events?.imgSrc} alt="test" style={{ width: "28px" }} />
            ) : (
              <img src={events?.whiteImgSrc} alt="test" style={{ width: "28px" }} />
            )}
          </MenuButton>
        ))}
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
